// Module
var code = "<div class=\"tabcontrol-tab\" v-show=\"isActive\"> <slot></slot> </div>";
// Exports
module.exports = code;